import { DataBean } from "../DataBean";

export class EmployeeDossier extends DataBean {

  public async getEmployeeDossierRender(page:number,rows:number,props:any): Promise<any> {
    return this.getCustomService(
      "TalentERP",
      "com.advantage.shared.Report_getEmployeeDossierRender_Number_Number_java.util.Map",
      [page,rows,props]
    );
  }

 
 
}
